<template>
  <nav class="level  has-text-light" style="margin: 0;">
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Age</p>
        <p class="title has-text-light"> {{ calculateAge }} </p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Years of <br>Expierence as <br> UX/UI designer</p>
        <p class="title has-text-light">3.5</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Years of <br>Expierence as <br> frontend dev</p>
        <p class="title has-text-light">2</p>
      </div>
    </div>
    <div class="level-item has-text-centered">
      <div>
        <p class="heading">Years of <br> work Experience</p>
        <p class="title has-text-light">5.5</p>
      </div>
    </div>
    <!-- <div class="level-item has-text-centered">
      <div>
        <p class="heading">Comics collected</p>
        <p class="title has-text-light">52</p>
      </div>
    </div> -->
  </nav>
</template>

<script>
export default {
  name: 'TrackerComponent',
  props: {
    msg: String
  }
  ,
    computed:{
        calculateAge: function() {
          let currentDate = new Date();
          let birthDate = new Date("1995/11/23");
          let difference = currentDate - birthDate;
          let age = Math.floor(difference/31557600000);
          return age
        }
    }
}

</script>

<style scoped>
  .level {
    padding: 5vw;
    margin: 0;
  }
  .level-item .title{
    font-size: 400%;
  }
  .heading {
    color: #efefef;
  }

  nav {
    background: linear-gradient(to top, rgba(107, 77, 168, 0.65) 0%, rgba(73, 119, 194, 0.65) 0%), url(../assets/intro-bg.jpeg) no-repeat ;
    background-position-y: 12%;
    background-size: 100%;
    background-repeat: none;
    margin: 0;
    height: 500px;
  }

  @media only screen and (max-width: 768px) {

    nav {
      background-size: auto;
    }

    .level-item .title {
      font-size: 300%;
    }

  }

</style>